<script setup>
import ProgressBar from "@/sections/my-goals/ProgressBar.vue";
import { useUserStore } from "@/store/user-store";
import { computed } from "vue";

const store = useUserStore();
const goals = computed(() => store.dashboardData.custGoals || []);
const gxrr = store.dashboardData.goalXrr;
const pxrr =
  store.dashboardData.portfolioDailySummary[
    store.dashboardData.portfolioDailySummary.length - 1
  ]?.portfolioXIRR;
</script>

<template>
  <div class="d-flex justify-between w-100 mt-30">
    <span class="font-20 font-weight-700">My Goals</span>
    <span
      :class="[
        'font-20 font-weight-700',
        { 'text-primary cursor-pointer': goals },
      ]"
      @click="
        () => {
          store.setTabView('My Goals');
          !store.goalSummary && store.loadGoalSummary();
        }
      "
      >See all</span
    >
  </div>
  <div
    class="d-flex flex-direction-column align-items-center input-shadow p-15 br-10 mt-20"
  >
    <div class="w-100 mt-50">
      <ProgressBar :goals="goals" />
    </div>
    <div
      class="d-flex flex-direction-column w-100 gap-20 mt-50"
      :style="{ color: goals.length === 0 && 'grey' }"
    >
      <div class="return-wrapper w-100 br-10 p-15 d-flex gap-10">
        <span>Required Rate of Returns:</span
        ><b>{{ goals.length === 0 ? 0 : gxrr }}%</b>
      </div>
      <div
        class="return-wrapper w-100 br-10 d-flex gap-15 p-15 align-items-center"
      >
        <span>My Portfolio Rate of Returns:</span
        ><b>{{ goals.length === 0 ? 0 : pxrr }}%</b
        ><span
          class="return-indicator"
          :style="{
            backgroundColor:
              goals.length === 0
                ? 'var(--an-gray)'
                : pxrr > gxrr
                ? 'var(--an-success)'
                : 'var(--an-error)',
          }"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.return-wrapper {
  border: 1px solid var(--an-gray1);
}

.return-indicator {
  height: 20px;
  width: 20px;
  border-radius: 50%;
}

table.striped tbody tr:nth-child(even) {
  background-color: var(--an-background-light);
}

.note {
  background-color: var(--an-error-background);
}

.goalDetails td,
.goalDetails th {
  padding: 15px 10px;
}

.custom-legend {
  grid-template-columns: repeat(2, 1fr);
}

.legend-color {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 3px;
}

.banner-wrapper {
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
}

.goal-pie {
  width: 350px;
}
</style>
